import { render, staticRenderFns } from "./PractitionerReport.vue?vue&type=template&id=6dfd6ae8&"
import script from "./PractitionerReport.vue?vue&type=script&lang=js&"
export * from "./PractitionerReport.vue?vue&type=script&lang=js&"
import style0 from "./PractitionerReport.vue?vue&type=style&index=0&id=6dfd6ae8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports